// Static changelog for the Developer Tools "Revision History" panel -- sourced
// from the repo's real merged PRs (numbers/titles/dates), not fabricated. Update
// this list by hand alongside each merged PR; there's no live GitHub call from the
// client, on purpose (no network dependency for a dev-only reference panel).

export interface RevisionEntry {
  number: number;
  title: string;
  date: string;
  url: string;
}

export const REVISION_HISTORY: RevisionEntry[] = [
  {
    number: 52,
    title: 'Sim extraction: the barrier chain and whole-room systems stop driving sprites and report events instead',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/52',
  },
  {
    number: 51,
    title: 'Sim extraction: one WorldState replaces five module-level singletons (player stats, inventory, doors, learned runes, marked source)',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/51',
  },
  {
    number: 50,
    title: 'Sim extraction: lift world types, tunable constants, the 11 room builders and the room queries into a renderer-free rune-lab/src/sim/',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/50',
  },
  {
    number: 49,
    title: 'room9: relocate a chasm to gate the entrance, and stop a push out of a river letting you stand in it',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/49',
  },
  {
    number: 48,
    title: 'Fix 4 real room9 bugs found by playing it (walkable water, anchored block, self-extinguishing bonfire, flow reset on re-entry) and stale dev room-jump labels',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/48',
  },
  {
    number: 47,
    title: 'rune-lab: add an Objects tab cataloging every object kind and every object mechanism',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/47',
  },
  {
    number: 46,
    title: 'Add first-Modifier and first-Transfer tutorial popups; fix a real room6 Entropy-transfer exploit',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/46',
  },
  {
    number: 45,
    title: 'Delete the Quarry Yard, renumber the room graph, and add room9: The Sundered Aqueduct (a water-flow puzzle)',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/45',
  },
  {
    number: 44,
    title: 'Doc accuracy pass on stale architecture claims; wire the real D1 database id into wrangler.jsonc',
    date: '2026-07-30',
    url: 'https://github.com/neilq1810/rune-world/pull/44',
  },
  {
    number: 43,
    title: 'Prepare the build for playtesters: hidden dev tools, a Portal feedback form, and anonymous analytics',
    date: '2026-07-29',
    url: 'https://github.com/neilq1810/rune-world/pull/43',
  },
  {
    number: 42,
    title: "Fix the uppercased rune-glyph title bug on all 4 crystals, add ward partial-progress, a Charge Reliquary lever gate, and a real fix for room4's ice-melt exploit",
    date: '2026-07-29',
    url: 'https://github.com/neilq1810/rune-world/pull/42',
  },
  {
    number: 41,
    title: "room8's Overseer Cache becomes a real η Crystal, and the endgame completes (all 4 crystals, room9's ε Crystal, bridge geometry)",
    date: '2026-07-29',
    url: 'https://github.com/neilq1810/rune-world/pull/41',
  },
  {
    number: 40,
    title: 'room10 becomes a real rune-altar puzzle (4 crystal pillars -> Portal); remove the Quarry Winch',
    date: '2026-07-29',
    url: 'https://github.com/neilq1810/rune-world/pull/40',
  },
  { number: 39, title: 'Pad/block render depth fix, room9 bridge cleanup, and room10 (the final portal room)', date: '2026-07-29', url: 'https://github.com/neilq1810/rune-world/pull/39' },
  { number: 38, title: 'room5 redesign: teach Reverse, add two Momentum·Project puzzles', date: '2026-07-29', url: 'https://github.com/neilq1810/rune-world/pull/38' },
  { number: 37, title: 'Add a grid-coordinates dev overlay; solid Blocks now stop Project beams', date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/37' },
  { number: 36, title: 'Speed up Energy regen, fix a Project conservation bug, and simplify modifiers', date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/36' },
  { number: 35, title: 'room2: gate the east door behind a new Warded Key', date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/35' },
  { number: 34, title: "room9: real bridge support pillars and a single-lane corridor; rewrite room0's opening bookshelf", date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/34' },
  { number: 33, title: 'Reset dev-only settings when Developer Tools is disabled', date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/33' },
  { number: 32, title: "room2 layout pass: real candle melt textures, a room8 hint, and pulling the unused Space rune", date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/32' },
  { number: 31, title: 'Add a visible cue for gaining Charge: an aura curve and a spark flash', date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/31' },
  { number: 30, title: 'Menu polish: Title Screen button beside Save/Resume, refined onboarding hints', date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/30' },
  { number: 29, title: 'Add an opening title screen with tutorial/dev-tools toggles; fix walkable objects rendering over the player', date: '2026-07-28', url: 'https://github.com/neilq1810/rune-world/pull/29' },
  { number: 28, title: 'Onboarding pass: interact hint, relocate Measure to room3, add the Equip/Cast tutorial', date: '2026-07-27', url: 'https://github.com/neilq1810/rune-world/pull/28' },
  {
    number: 27,
    title: 'Player aura, HUD/debug polish, rune naming, room8/9 fixes, Project·Momentum, and a room6 puzzle redesign',
    date: '2026-07-27',
    url: 'https://github.com/neilq1810/rune-world/pull/27',
  },
  { number: 26, title: 'Add room9: charge conduction gated puzzle, then an entropy-collapsed bridge', date: '2026-07-27', url: 'https://github.com/neilq1810/rune-world/pull/26' },
  { number: 25, title: 'Add room name HUD, dialogue-box keyboard nav, dev signposts, and a Measure visual overhaul', date: '2026-07-27', url: 'https://github.com/neilq1810/rune-world/pull/25' },
  { number: 24, title: 'Add a v1-prototyped Combinations status for real, working game/ mechanics', date: '2026-07-27', url: 'https://github.com/neilq1810/rune-world/pull/24' },
  { number: 23, title: 'Add Charge as a real player reserve; Project·Charge fires a lightning bolt', date: '2026-07-27', url: 'https://github.com/neilq1810/rune-world/pull/23' },
  { number: 22, title: 'Move cast-result HUD to top-right, add 4-quadrant equip hotbar', date: '2026-07-27', url: 'https://github.com/neilq1810/rune-world/pull/22' },
  { number: 21, title: 'Move equipped-line HUD up, add Project flame FX, hide facing text by default', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/21' },
  { number: 20, title: 'HUD layout pass: reposition Menu/action buttons, widen result box, tap-to-dismiss', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/20' },
  { number: 19, title: 'Condense Menu/Notebook/Inventory into one panel with tabs', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/19' },
  { number: 18, title: 'Add a Developer Tools debug overlay: live Energy/Charge/Health readouts', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/18' },
  { number: 17, title: 'Move Menu/Inventory/Notebook buttons to the bottom of the screen', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/17' },
  { number: 16, title: 'Center small rooms on screen instead of pinning them to the top-left', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/16' },
  { number: 15, title: 'Add a second environmental-property puzzle: Charge in room3', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/15' },
  { number: 14, title: 'Move Rune display and Cast result text into Developer Tools', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/14' },
  { number: 13, title: 'Require standing beside an object to interact with it, same as a door', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/13' },
  { number: 12, title: 'Make the demo Ice Block meltable, and stop panels from being click-hijacked', date: '2026-07-26', url: 'https://github.com/neilq1810/rune-world/pull/12' },
  { number: 11, title: 'Add more crates, one hiding a mysterious item', date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/11' },
  { number: 10, title: 'Add rooms 3-4, thematic props, and non-cast object interactions', date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/10' },
  { number: 9, title: "Wire rune-lab's resolve() engine into casting; fix a flex-shrink clipping bug", date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/9' },
  { number: 8, title: 'Add bookshelves and multi-rune casting on objects', date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/8' },
  { number: 7, title: 'Add Notebook (rune detail pages), HUD bars, object casting, door lock', date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/7' },
  { number: 6, title: 'Populate the Runes panel with color-coded runes, add shorthand/symbols toggle', date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/6' },
  { number: 5, title: 'Add a second room, door, and menu/rune UI placeholders', date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/5' },
  { number: 4, title: 'Fix blank screen on mobile: canvas was letterboxed to a sliver', date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/4' },
  { number: 3, title: 'Scaffold Phaser game (walk-around) and resolve modifier/noun brainstorm', date: '2026-07-25', url: 'https://github.com/neilq1810/rune-world/pull/3' },
];
